import type { TextBlock } from '../../../../../types/MiniSiteContents';
import ContentWrapper from '../../../common/ContentWrapper';
import Markdown from '../../../common/Markdown/Markdown';

type Props = {
  miniSiteContent: TextBlock;
};

const MiniSiteTextBlock = ({ miniSiteContent }: Props) => {
  const { contentTitle, title, description, link } = miniSiteContent;

  const content = (
    <div className="flex w-full flex-col gap-2 rounded-lg bg-white p-7 md:px-10 md:py-5">
      {title && <p className="text-large font-bold">{title}</p>}
      {description && <Markdown className="text-small">{description}</Markdown>}
    </div>
  );

  return (
    <ContentWrapper className="w-full">
      {contentTitle && <p className="pb-6 text-title3 font-bold">{contentTitle}</p>}
      {link ? (
        <div
          onClick={() => {
            window.open(link, '_blank');
          }}
          onKeyDown={() => {
            window.open(link, '_blank');
          }}
          role="button"
          tabIndex={0}
        >
          {content}
        </div>
      ) : (
        content
      )}
    </ContentWrapper>
  );
};

export default MiniSiteTextBlock;
